<template>
    <div>
        <alert-container :messages="msgs" />
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        (allowedCreateMotivo || allowedUpdateMotivo) && !motivoatendimentoIntegracao
                    "
                    class="save-btn"
                    type="button"
                    @click="save()"
                    :disabled="isSaving"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-3">
                    <v-input
                        :id="generateId(1)"
                        ref="idErpInput"
                        v-model="motivoatendimento.idMotivoAtendimentoErp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        uppercase
                        :required="isUpdate"
                        :invalid="isUpdate && isNull(motivoatendimento.idMotivoAtendimentoErp)"
                        :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                        :disabled="motivoatendimentoIntegracao"
                    />
                </div>
                <div class="column is-9">
                    <v-input
                        :id="generateId(2)"
                        v-model="motivoatendimento.descricao"
                        ref="descricaoInput"
                        placeholder="descricao-do-motivo-atendimento-placeholder"
                        title="descricao"
                        :maxlength="100"
                        :invalid="!motivoatendimento.descricao"
                        uppercase
                        tooltipLabel="info-descricao-generica"
                        required
                        :disabled="motivoatendimentoIntegracao"
                    />
                </div>
            </div>
            <div class="columns head is-flex-wrap">
                <div class="column is-4">
                    <IconsSelect
                        :id="generateId(3)"
                        title="icone"
                        @changeIcon="changeIcon"
                        required
                        ref="iconeInput"
                        msg="msg-campo-obrigatorio"
                        :invalid="invalidIcon"
                        :iconClass="motivoatendimento.icone"
                        :icons="icones"
                        :disabled="motivoatendimentoIntegracao"
                    ></IconsSelect>
                </div>
                <div class="column is-4">
                    <color-picker
                        title="selecione-uma-cor"
                        :id="generateId(4)"
                        :color="motivoatendimento.cor"
                        ref="corInput"
                        @colorpicked="colorpicked"
                        :disabled="motivoatendimentoIntegracao"
                    />
                </div>
                <div class="column is-4">
                    <v-input
                        :id="generateId(5)"
                        v-model="motivoatendimento.qtdMinimaFoto"
                        ref="minFotosInput"
                        title="minimo-fotos"
                        step="1"
                        :invalid="!motivoatendimento.qtdMinimaFoto"
                        :maxlength="3"
                        :min="0"
                        validchars="0123456789"
                        required
                        tooltipLabel="info-qtde-minima-foto"
                        tooltipPosition="is-left"
                        :disabled="motivoatendimentoIntegracao"
                    />
                </div>
            </div>
            <div class="columns is-flex-wrap">
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-data-atendimento') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-data-atendimento') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(22)"
                            :type="checks.dataAtendimento.habilita ? 'is-primary' : ''"
                            :outlined="!checks.dataAtendimento.habilita"
                            @click="changeCheckHabilita('dataAtendimento')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(23)"
                            :type="checks.dataAtendimento.obriga ? 'is-primary' : ''"
                            :outlined="!checks.dataAtendimento.obriga"
                            @click="changeCheckObriga('dataAtendimento')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-propriedade') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga',
                                { n: $t('motivo-atendimento-propriedade') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(8)"
                            :type="checks.propriedade.habilita ? 'is-primary' : ''"
                            :outlined="!checks.propriedade.habilita"
                            :disabled="obrigaPropriedade"
                            @click="changeCheckHabilita('propriedade')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(9)"
                            :type="checks.propriedade.obriga ? 'is-primary' : ''"
                            :outlined="!checks.propriedade.obriga"
                            :disabled="obrigaPropriedade"
                            @click="changeCheckObriga('propriedade')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-area') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-area') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(10)"
                            :type="checks.area.habilita ? 'is-primary' : ''"
                            :outlined="!checks.area.habilita"
                            :disabled="obrigaArea"
                            @click="changeCheckHabilita('area')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(11)"
                            :type="checks.area.obriga ? 'is-primary' : ''"
                            :outlined="!checks.area.obriga"
                            :disabled="obrigaArea"
                            @click="changeCheckObriga('area')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-talhao') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-talhao') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(12)"
                            :type="checks.talhao.habilita ? 'is-primary' : ''"
                            :outlined="!checks.talhao.habilita"
                            @click="changeCheckHabilita('talhao')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(13)"
                            :type="checks.talhao.obriga ? 'is-primary' : ''"
                            :outlined="!checks.talhao.obriga"
                            @click="changeCheckObriga('talhao')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
            </div>
            <div class="columns is-flex-wrap">
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-cultura') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-cultura') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(16)"
                            :type="checks.cultura.habilita ? 'is-primary' : ''"
                            :outlined="!checks.cultura.habilita"
                            :disabled="obrigaCultura"
                            @click="changeCheckHabilita('cultura')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(17)"
                            :type="checks.cultura.obriga ? 'is-primary' : ''"
                            :outlined="!checks.cultura.obriga"
                            :disabled="obrigaCultura"
                            @click="changeCheckObriga('cultura')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-cultivar') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-cultivar') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(18)"
                            :type="checks.cultivar.habilita ? 'is-primary' : ''"
                            :outlined="!checks.cultivar.habilita"
                            @click="changeCheckHabilita('cultivar')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(19)"
                            :type="checks.cultivar.obriga ? 'is-primary' : ''"
                            :outlined="!checks.cultivar.obriga"
                            @click="changeCheckObriga('cultivar')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-fase-fenologica') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-fase-fenologica') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(20)"
                            :type="checks.faseFenologica.habilita ? 'is-primary' : ''"
                            :outlined="!checks.faseFenologica.habilita"
                            @click="changeCheckHabilita('faseFenologica')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(21)"
                            :type="checks.faseFenologica.obriga ? 'is-primary' : ''"
                            :outlined="!checks.faseFenologica.obriga"
                            @click="changeCheckObriga('faseFenologica')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-safra') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-safra') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(14)"
                            :type="checks.safra.habilita ? 'is-primary' : ''"
                            :outlined="!checks.safra.habilita"
                            @click="changeCheckHabilita('safra')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(15)"
                            :type="checks.safra.obriga ? 'is-primary' : ''"
                            :outlined="!checks.safra.obriga"
                            @click="changeCheckObriga('safra')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
            </div>
            <div class="columns is-flex-wrap">
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-tipo-agrovisita') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-tipo-agrovisita') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(24)"
                            :type="checks.tipoAgrovisita.habilita ? 'is-primary' : ''"
                            :outlined="!checks.tipoAgrovisita.habilita"
                            @click="changeCheckHabilita('tipoAgrovisita')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(25)"
                            :type="checks.tipoAgrovisita.obriga ? 'is-primary' : ''"
                            :outlined="!checks.tipoAgrovisita.obriga"
                            @click="changeCheckObriga('tipoAgrovisita')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-assunto-agrovisita') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-assunto-agrovisita') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(26)"
                            :type="checks.assuntoAgrovisita.habilita ? 'is-primary' : ''"
                            :outlined="!checks.assuntoAgrovisita.habilita"
                            @click="changeCheckHabilita('assuntoAgrovisita')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(27)"
                            :type="checks.assuntoAgrovisita.obriga ? 'is-primary' : ''"
                            :outlined="!checks.assuntoAgrovisita.obriga"
                            @click="changeCheckObriga('assuntoAgrovisita')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-contato') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-contato') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(6)"
                            :type="checks.contato.habilita ? 'is-primary' : ''"
                            :outlined="!checks.contato.habilita"
                            @click="changeCheckHabilita('contato')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(7)"
                            :type="checks.contato.obriga ? 'is-primary' : ''"
                            :outlined="!checks.contato.obriga"
                            @click="changeCheckObriga('contato')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-contato-texto') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-contato-texto') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(6)"
                            :type="checks.contatoTexto.habilita ? 'is-primary' : ''"
                            :outlined="!checks.contatoTexto.habilita"
                            @click="changeCheckHabilita('contatoTexto')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(7)"
                            :type="checks.contatoTexto.obriga ? 'is-primary' : ''"
                            :outlined="!checks.contatoTexto.obriga"
                            @click="changeCheckObriga('contatoTexto')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <div class="column is-3">
                    <label>
                        {{ $t('motivo-atendimento-observacao-geral') }}
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('motivo-atendimento-habilita-obriga', 
                                { n: $t('motivo-atendimento-observacao-geral') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(28)"
                            :type="checks.observacaoGeral.habilita ? 'is-primary' : ''"
                            :outlined="!checks.observacaoGeral.habilita"
                            @click="changeCheckHabilita('observacaoGeral')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(29)"
                            :type="checks.observacaoGeral.obriga ? 'is-primary' : ''"
                            :outlined="!checks.observacaoGeral.obriga"
                            @click="changeCheckObriga('observacaoGeral')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MotivoAtendimentoService from '@/services/MotivoAtendimentoService';
import MotivoAtendimentoValidation from '@/services/validations/MotivoAtendimentoValidation';
import Message from '@/models/Message';
import ColorPicker from '@/components/shared/form/ColorPicker';
import IconsSelect from '@/components/shared/form/IconsSelect';

export default {
    components: {
        IconsSelect,
        ColorPicker,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        motivoatendimento: {
            deep: true,
            handler: function () {
                if (!this.isLoading) {
                    this.$emit('isChanged', true);
                }
            },
        },
        checks: {
            deep: true,
            handler: function () {
                if (!this.isLoading) {
                    this.$emit('isChanged', true);
                }
            },
        },
    },
    data() {
        return {
            msgs: [],
            motivoatendimentoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'CRM_MOTIVO_ATENDIMENTO'
            ),
            service: new MotivoAtendimentoService(this.$http, this.$router),
            validation: null,
            isInitialLoadComplete: false,
            isSaving: false,
            isLoading: false,
            motivoatendimento: {
                descricao: '',
                idMotivoAtendimentoErp: null,
                icone: '',
                cor: '#D0CFCF',
                qtdMinimaFoto: 0,
                habilitaObrigaContato: null,
                habilitaObrigaContatoTexto: null,
                habilitaObrigaPropriedade: null,
                habilitaObrigaArea: null,
                habilitaObrigaTalhao: null,
                habilitaObrigaSafra: null,
                habilitaObrigaCultura: null,
                habilitaObrigaCultivar: null,
                habilitaObrigaFaseFenologica: null,
                habilitaObrigaDataAtendimento: null,
                habilitaObrigaObservacao: null,
                habilitaObrigaAssuntoAgroVisita: null,
                habilitaObrigaTipoAgroVisita: null,
                habilitaObrigaFormulario: null,
            },
            checks: {
                contato: { habilita: false, obriga: false },
                contatoTexto: { habilita: false, obriga: false },
                propriedade: { habilita: false, obriga: false },
                area: { habilita: false, obriga: false },
                talhao: { habilita: false, obriga: false },
                safra: { habilita: false, obriga: false },
                cultura: { habilita: false, obriga: false },
                cultivar: { habilita: false, obriga: false },
                faseFenologica: { habilita: false, obriga: false },
                dataAtendimento: { habilita: false, obriga: false },
                tipoAgrovisita: { habilita: false, obriga: false },
                assuntoAgrovisita: { habilita: false, obriga: false },
                observacaoGeral: { habilita: false, obriga: false },
                formulario: { habilita: false, obriga: false },
            },
            permissao: {},
            invalidIcon: false,
            icones: [
                { pack: 'fas', class: 'feather-alt' },
                { pack: 'fas', class: 'bug' },
                { pack: 'fas', class: 'viruses' },
                { pack: 'fas', class: 'disease' },
                { pack: 'fas', class: 'snowflake' },
                { pack: 'fas', class: 'spa' },
                { pack: 'fas', class: 'wind' },
                { pack: 'fas', class: 'temperature-high' },
                { pack: 'fas', class: 'temperature-low' },
                { pack: 'fas', class: 'money-check-alt' },
                { pack: 'fas', class: 'exclamation-triangle' },
                { pack: 'fas', class: 'times' },
            ],
            obrigaPropriedade: false,
            obrigaArea: false,
            obrigaCultura: false,
            dependentFields: [
                { key: 'cultivar' },
                { key: 'faseFenologica' },
                { key: 'area' },
                { key: 'talhao' },
            ],
            originalIdErp: ''
        };
    },
    computed: {
        allowedCreateMotivo() {
            return !this.isUpdate && this.permissao.create;
        },
        allowedUpdateMotivo() {
            return this.isUpdate && this.permissao.update;
        },
    },
    created() {
        this.validation = new MotivoAtendimentoValidation(this.msgs);

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-motivo-atendimento');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'ven-motivo-atendimento' },
            });

        !this.isUpdate &&
            !this.allowedCreateMotivo &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'ven-motivo-atendimento' },
            });

        if (this.$route.params.id) {
            this.carregarDados(this.$route.params.id);
        }

        setTimeout(() => {
            this.$emit('isChanged', false);
        }, 1000);
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.$store.commit('addLoader');
            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.motivoatendimento = body.content;
                        const title = this.motivoatendimento.descricao;

                        this.$emit('descricao', title);

                        this.originalIdErp = this.motivoatendimento.idMotivoAtendimentoErp;
                    } else {
                        this.$router.push({
                            name: 'ven-motivo-atendimento-new',
                        });
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar motivo de atendimento.', e);
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    this.mapHabilita();
                    this.mapObriga();
                    this.checkHabilitaObrigaDependencies();
                    this.$store.commit('removeLoader');
                    this.isLoading = false;
                    this.$emit('isChanged', false);
                    this.isInitialLoadComplete = true;
                });
        },
        mapHabilita() {
            this.checks.contato.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaContato
            );
            this.checks.contatoTexto.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaContatoTexto
            );
            this.checks.propriedade.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaPropriedade
            );
            this.checks.area.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaArea
            );
            this.checks.talhao.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaTalhao
            );
            this.checks.safra.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaSafra
            );
            this.checks.cultura.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaCultura
            );
            this.checks.cultivar.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaCultivar
            );
            this.checks.faseFenologica.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaFaseFenologica
            );
            this.checks.dataAtendimento.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaDataAtendimento
            );
            this.checks.tipoAgrovisita.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaTipoAgroVisita
            );
            this.checks.assuntoAgrovisita.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaAssuntoAgroVisita
            );
            this.checks.observacaoGeral.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaObservacao
            );
            this.checks.formulario.habilita = this.mapChecksHabilita(
                this.motivoatendimento.habilitaObrigaFormulario
            );
        },
        mapObriga() {
            this.checks.contato.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaContato
            );
            this.checks.contatoTexto.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaContatoTexto
            );
            this.checks.propriedade.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaPropriedade
            );
            this.checks.area.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaArea
            );
            this.checks.talhao.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaTalhao
            );
            this.checks.safra.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaSafra
            );
            this.checks.cultura.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaCultura
            );
            this.checks.cultivar.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaCultivar
            );
            this.checks.faseFenologica.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaFaseFenologica
            );
            this.checks.dataAtendimento.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaDataAtendimento
            );
            this.checks.tipoAgrovisita.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaTipoAgroVisita
            );
            this.checks.assuntoAgrovisita.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaAssuntoAgroVisita
            );
            this.checks.observacaoGeral.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaObservacao
            );
            this.checks.formulario.obriga = this.mapChecksObriga(
                this.motivoatendimento.habilitaObrigaFormulario
            );
        },
        checkHabilitaObrigaDependencies() {
            this.dependentFields.forEach((obj) => this.checkDependencies(obj.key));
        },
        save() {
            this.motivoatendimento = this.mapTosave(this.motivoatendimento);
            this.invalidIcon = this.motivoatendimento.icone == '';
            if (this.validation.validate(this.motivoatendimento, this.$refs) && !this.invalidIcon) {
                if(this.isPrefixSovisInIdErpInvalid(this.motivoatendimento.idMotivoAtendimentoErp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';
                    
                    return this.$root.showMessage('alert', message, true);
                }

                this.isSaving = true;
                this.mapSaveChecks();
                this.service
                    .save(this.motivoatendimento)
                    .then((body) => {

                        const motivoAtendimento = body.content;

                        let msg = 'msg-motivoatendimento-salva';

                        if (motivoAtendimento.id) {
                            msg = 'msg-motivoatendimento-edita';
                        }

                        this.$root.showMessage('success', msg);
                        this.$emit('isChanged', false);
                        this.$emit('redirect', motivoAtendimento.id);
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(message, { n: this.motivoatendimento.idMotivoAtendimentoErp }),
                                        true,
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
            }
        },
        mapSaveChecks() {
            this.motivoatendimento.habilitaObrigaContato = this.setChecksToSave(
                this.checks.contato
            );
            this.motivoatendimento.habilitaObrigaContatoTexto = this.setChecksToSave(
                this.checks.contatoTexto
            );
            this.motivoatendimento.habilitaObrigaPropriedade = this.setChecksToSave(
                this.checks.propriedade
            );
            this.motivoatendimento.habilitaObrigaArea = this.setChecksToSave(this.checks.area);
            this.motivoatendimento.habilitaObrigaTalhao = this.setChecksToSave(this.checks.talhao);
            this.motivoatendimento.habilitaObrigaSafra = this.setChecksToSave(this.checks.safra);
            this.motivoatendimento.habilitaObrigaCultura = this.setChecksToSave(
                this.checks.cultura
            );
            this.motivoatendimento.habilitaObrigaCultivar = this.setChecksToSave(
                this.checks.cultivar
            );
            this.motivoatendimento.habilitaObrigaFaseFenologica = this.setChecksToSave(
                this.checks.faseFenologica
            );
            this.motivoatendimento.habilitaObrigaDataAtendimento = this.setChecksToSave(
                this.checks.dataAtendimento
            );
            this.motivoatendimento.habilitaObrigaTipoAgroVisita = this.setChecksToSave(
                this.checks.tipoAgrovisita
            );
            this.motivoatendimento.habilitaObrigaAssuntoAgroVisita = this.setChecksToSave(
                this.checks.assuntoAgrovisita
            );
            this.motivoatendimento.habilitaObrigaObservacao = this.setChecksToSave(
                this.checks.observacaoGeral
            );
            this.motivoatendimento.habilitaObrigaFormulario = this.setChecksToSave(
                this.checks.formulario
            );
        },
        changeCheckHabilita(item) {
            this.checks[item].habilita = !this.checks[item].habilita;
            if (!this.checks[item].habilita) this.checks[item].obriga = false;
            this.checkDependencies(item);
        },
        changeCheckObriga(item) {
            this.checks[item].obriga = !this.checks[item].obriga;
            if (this.checks[item].obriga) this.checks[item].habilita = true;
            this.checkDependencies(item);
        },
        uncheckDependencies(item) {
            this.checks[item].habilita = false;
            this.checks[item].obriga = false;
            this.checkDependencies(item);
        },
        habilitaObriga(item) {
            this.isHabilitaObrigaOn = true;
            this.checks[item].habilita = true;
            this.checks[item].obriga = true;
            this.checkDependencies(item);
        },
        checkDependencies(item) {

            const habilita = this.checks[item].habilita;
            const obriga = this.checks[item].obriga;

            const habilitaObriga = habilita && (!obriga || obriga);
            const notHabilitaObriga = !habilita && !obriga;

            switch (item) {
                case 'area':
                    if (habilitaObriga) {
                        this.habilitaObriga('propriedade');
                        this.obrigaPropriedade = true;
                    } else if (notHabilitaObriga) {
                        this.isInitialLoadComplete ? this.uncheckDependencies('propriedade'): '';
                        this.obrigaPropriedade = false;
                    }
                    break;
                case 'talhao':
                    if (habilitaObriga) {
                        this.habilitaObriga('area');
                        this.obrigaArea = true;
                    } else if (notHabilitaObriga) {
                        this.isInitialLoadComplete ? this.uncheckDependencies('area'): '';
                        this.obrigaArea = false;
                    }
                    break;
                case 'cultivar':
                case 'faseFenologica':
                    const cultivarOrFaseFenologica =
                        this.checks['cultivar'].habilita || this.checks['faseFenologica'].habilita;

                    if (habilitaObriga) {
                        this.habilitaObriga('cultura');
                        this.obrigaCultura = true;
                    } else if (!cultivarOrFaseFenologica && !obriga) {
                        this.isInitialLoadComplete ? this.uncheckDependencies('cultura'): '';
                        this.obrigaCultura = false;
                    }
                    break;
                default:
                    break;
            }
        },
        changeIcon(icon) {
            this.motivoatendimento.icone = icon;
        },
        colorpicked(color) {
            this.motivoatendimento.cor = color;
        },
        setChecksToSave(obj) {
            if (obj.obriga) {
                return 2;
            } else if (obj.habilita) {
                return 1;
            } else {
                return 0;
            }
        },
        mapChecksObriga(check) {
            return check == 2;
        },
        mapChecksHabilita(check) {
            return check == 1 || check == 2;
        },
    },
};
</script>

<style lang="scss" scoped>
.page-container {
    .head {
        margin-bottom: 30px;
    }
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>
